import * as storage from '@/modules/auth/storage'
import { infraMixin } from '@/modules/infra/mixins'
import util from '@/util'
import constants from '@/util/constants'
import { obterImagem, obterIcone } from '@/util/imagem'
import mensagens from '@/util/mensagens'
import { BSpinner, BToast } from 'bootstrap-vue'
import { mapActions, mapGetters, mapState } from 'vuex'
// import cookieUtil from '@/util/cookieUtil'

export default {
  name: 'RecuperacaoSenhaOffice',
  components: {
    'b-spinner': BSpinner,
    'b-toast': BToast
  },
  mixins: [infraMixin],
  computed: {
    ...mapState('auth', ['escritorio', 'logoCliente', 'nomeUsuarioLogado', 'emailUsuario', 'idUsuarioLogado', 'dataCriacaoUsuarioLogado']),
    mostrarBotaoOutroEscritorio () {
      const temEscritorioLogado = !this.flags.escritorioNaoLogado
      return temEscritorioLogado
    },
    obterLogo () {
      return obterImagem('logo-office300.png')
    },
    iconePreambulo () {
      return obterIcone('icone-preambulo.png')
    },
    recuperacaoPeloSso () {
      return Boolean(this.retorno.listaDados && this.retorno.listaDados.recuperacao_pelo_sso === true)
    }
  },
  data: () => ({
    dadosFormulario: {
      identifier: '',
      tenant: ''
    },
    emailRecuperacao: null,
    retorno: {
      sucesso: false,
      mensagem: '',
      listaDeErros: [],
      listaDados: []
    },
    flags: {
      efetuandoRequisicao: false,
      escritorioNaoLogado: false
    },
    temLogoClienteNaSessao: false,
    callbackAposLoginSucesso: null
  }),

  async mounted () {
    this.ActionSetLogoCliente('')
    this.verificarEscritorioLogado()
  },

  methods: {
    ...mapActions('auth', ['ActionSetLoginStrategy', 'ActionSignOut', 'ActionSetLogoCliente', 'ActionSetEscritorio', 'ActionSetTipoDeAcesso', 'ActionSetPerfilUsuario', 'ActionSetAcessoFinanceiro', 'ActionSetAcessoFaturamento', 'ActionSetNomeUsuarioLogado', 'ActionSetAcessoEscritorio', 'ActionSetFinanceiroContratado', 'ActionSetFaturamentoContratado', 'ActionSetCodigoFotoUsuario', 'ActionSetEscritorioInadimplente', 'ActionSetIdUsuarioLogado', 'ActionSetDataCriacaoUsuarioLogado', 'ActionSetEmailUsuario', 'ActionSetSuporteOnlineHabilitado', 'ActionSetIdEmpresa']),
    ...mapGetters('auth', ['temEscritorio', 'temLogoCliente']),

    async verificarEscritorioLogado () {
      const escritorioUrl = this.$route.params.escritorio
      const temEscritorioNaUrl = !util.valorVazio(escritorioUrl)
      if (temEscritorioNaUrl) {
        this.definirEscritorioPelaURL(escritorioUrl)
      }
      this.flags.escritorioNaoLogado = !this.temEscritorio()
      if (this.temEscritorio()) {
        this.dadosFormulario.tenant = this.escritorio
        await this.definirLogotipoPeloEscritorio(this.escritorio)
      }
    },

    definirEscritorioPelaURL (escritorioUrl) {
      this.ActionSetEscritorio(escritorioUrl)
    },

    async definirLogotipoPeloEscritorio (escritorio) {
      try {
        const resposta = await this.axios.get('/escritorio/' + escritorio + '/logotipo')
        const dadosRespostaRequisicao = resposta.data.retorno
        if (dadosRespostaRequisicao.success === true) {
          this.ActionSetLogoCliente(dadosRespostaRequisicao.f_client_logo)
          this.temLogoClienteNaSessao = this.temLogoCliente()
        } else {
          this.acessarComOutroEscritorio()
        }
      } catch (e) {
        this.acessarComOutroEscritorio()
      }
    },

    eventoLoginTeclaEnter (evento) {
      if (evento.keyCode === constants.teclado.enter) {
        this.recuperar()
      }
    },

    async recuperar () {
      if (this.flags.efetuandoRequisicao !== true) {
        this.callbackAposLoginSucesso = null
        this.retorno.mensagem = ''
        this.retorno.sucesso = false
        this.retorno.listaDados = []
        const validacaoSucesso = this.validarDadosFormulario()
        if (validacaoSucesso) {
          await this.efetuarRecuperacaoSenha()
        }
      }
    },

    validarDadosFormulario () {
      this.retorno.listaDeErros = []
      const dados = this.dadosFormulario
      let validacaoSucesso = true

      for (let indice in dados) {
        let campo = dados[indice].trim()
        if (util.valorVazio(campo)) {
          this.retorno.listaDeErros[indice] = 'Este campo é obrigatório'
          validacaoSucesso = false
        }
      }

      return validacaoSucesso
    },

    async efetuarRecuperacaoSenha () {
      const resposta = await this.realizarRequisicaoRecuperacaoSenha()
      this.retorno = { ...resposta.retorno }
      if (this.retorno.sucesso) {
        this.emailRecuperacao = this.retorno.listaDados.email ?? ''
        this.definirDadosDeAcesso()
      }
    },

    async realizarRequisicaoRecuperacaoSenha () {
      let dadosRespostaRequisicao = null
      this.flags.efetuandoRequisicao = true
      try {
        const resposta = await this.axios.post('/manager/recuperar-senha-office', {
          'identifier': this.dadosFormulario.identifier,
          'tenant': this.dadosFormulario.tenant
        })
        dadosRespostaRequisicao = resposta.data
      } catch (e) {
        this.flags.efetuandoRequisicao = false
        this.retorno.mensagem = mensagens.falhaComunicacaoServidor
      } finally {
        this.flags.efetuandoRequisicao = false
      }
      return dadosRespostaRequisicao
    },

    async definirDadosDeAcesso () {
      const escritorio = this.dadosFormulario.tenant.trim()
      this.definirLogotipoPeloEscritorio(escritorio)
    },

    irParaLoginPreambulo () {
      this.$router.push({
        name: constants.nomeRotaLoginComEscritorioNaURL,
        params: { escritorio: this.dadosFormulario.tenant.trim() },
        query: { user: this.dadosFormulario.identifier.trim() }
      })
    },

    acessarComOutroEscritorio () {
      this.flags.escritorioNaoLogado = true
      this.dadosFormulario.tenant = ''
      this.temLogoClienteNaSessao = false
      this.retorno.listaDeErros = []
      this.ActionSetLogoCliente('')
      this.ActionSetEscritorio('')
      storage.deleteLogoCliente()
      storage.deleteEscritorio()
    }
  }
}
